import { render } from "./OpportunityTmplInfo.vue?vue&type=template&id=356a3d47&scoped=true&lang=true"
import script from "./OpportunityTmplInfo.vue?vue&type=script&lang=js"
export * from "./OpportunityTmplInfo.vue?vue&type=script&lang=js"

import "./OpportunityTmplInfo.vue?vue&type=style&index=0&id=356a3d47&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-356a3d47"

export default script